import { Row, Col, Container, Image } from 'react-bootstrap';
// import TextType from './TextType';
import './BackgroundCarousel.css';
import './Typed.css';
// import FlyRugImg from '../Img/ImageToStl.com_flying_carpet.jpg'
// import PixelTransition from './PixelTransition';
// import ModelViewer from './ModelViewer';
// import { Link } from 'react-router-dom';
// import ScrollReveal from './ScrollReveal';

// import AboutImg from '../Img/rug-vs-rag-infographic.png';

//Products
// import Furniture from '../Img/Products/Furniture.jpg';
// import Rug from '../Img/Products/Rugs.jpg';
// import Cushions from '../Img/Products/Cushions.jpg';
// import BedBath from '../Img/Products/BedBath.jpg';
// import KitchenDining from '../Img/Products/kitchen-and-dining.jpg';
// import DecorAccessories from '../Img/Products/Decor-Accessories.png';
// import Lights from '../Img/Products/Lights.jpeg';
// import Bag from '../Img/Products/Bag.png';
// import Holiday from '../Img/Products/Holiday.jpg';


//Banner
import Img from '../Img/Banner/Banner-4.jpg';
// import Banner1 from "../Img/Banner/Banner-1.jpg";
// import Banner2 from "../Img/Banner/Banner-2.png";
// import Banner3 from "../Img/Banner/Banner-3.png";
// import Banner4 from "../Img/Banner/Banner-4.jpg";

function DarkVariantExample() {

  // const images = [
  //   // Banner1,
  //   // Banner2,
  //   // Banner3,
  //   Banner4,
  // ];
  return (
    <>
      <div className="image-container">
        <Image
          className="fade-in responsive-img"
          src={Img}
          height={500}
          width="100%"
          fluid
        />

        {/* <Row className="justify-content-start overlay-row">
          <Col md={6}>
            <p className="overlay-text fs-3 justify-text">
              We Represent Custom Rugs, Retailers, Wholesalers, Importers and Chain Stores for their Buying Requirements and Manage the Entire Sourcing Process End-to-End.
            </p>
          </Col>
        </Row> */}
      </div>
      {/* <div>
        <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />
        <p className='fs-3 justify-text'>We Represent Custom Rugs, Retailers, Wholesalers, Importers and Chain Stores for their Buying Requirements and Manage the Entire Sourcing Process End-to-End.</p>
    </div> */}
      {/* === Hero Section === */}
      {/* <div>
        <Carousel indicators={false} fade interval={5000} className="bg-carousel">
          {images.map((src, index) => (
            <Carousel.Item key={index}>
              <div
                className="carousel-background"
                style={{ backgroundImage: `url(${src})` }}
              ></div> */}

      {/* <Carousel.Caption className="d-flex justify-content-center align-items-center text-center caption-full"> */}
      <Container>
        <Row className="justify-content-start">
          <Col md={7}>
            <div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              className="mt-3 fs-5"
            >
              {/* <div className='typed-text1'>
                          <TextType
                            text={["Work Together", "Grow Together"]}
                            typingSpeed={75}
                            pauseDuration={1500}
                            showCursor={true}
                            cursorCharacter="_"
                          />
                        </div> */}
              {/* <p className='fs-3 justify-text'>
                          We Represent Custom Rugs, Retailers, Wholesalers, Importers and Chain Stores for their Buying Requirements and Manage the Entire Sourcing Process End-to-End.
                        </p> */}
            </div>
          </Col>
          <Col md={5}>
            {/* <ModelViewer
                        // url="https://raw.githubusercontent.com/KhronosGroup/glTF-Sample-Models/main/2.0/ToyCar/glTF-Binary/ToyCar.glb"
                        url={FlyRugImg}
                        width={400}
                        height={400}
                      /> */}
          </Col>
        </Row>
      </Container>
      {/* </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </div> */}
      {/* === Hero Section === */}
      <Container>
        <Row className="d-flex justify-content-center">
          <Col className="p-5">
            {/* <h1 className="mb-4"> <strong>About Us</strong></h1>
            <p style={{ fontSize: '20px' }}>
              For over 27 years, Bharat Rug Agency, has specialized in procuring and
              supplying the ﬁnest home furnishings from across the Indian subcontinent
              to stores all over the world. We represent retailers, wholesalers,
              importers and specialty stores for their buying requirements and manage
              the entire sourcing process end-to-end.
            </p> */}
            <h1 className="mb-4 text-center" style={{ fontWeight: 800 }}>About Us</h1>
            <p style={{ fontSize: '20px' }} className=''>Bharat Rug Agencies is working as Buying & sourcing Agency for Carpets and Rugs with home Textiles products since 2004, having Family Roots in Business since 1988.</p>
            <p style={{ fontSize: '20px' }} className=''>We represent Custom rugs, retailers, wholesalers, importers and chain stores for their buying requirements and manage the entire sourcing process end-to-end.</p>
            <p style={{ fontSize: '20px' }} className=''>We have built long-lasting ties with our vendors and aim to bring our clients the best quality products at value prices.</p>
            <p style={{ fontSize: '20px' }} className=''>Bharat Rug Agency Know that success is build on strong relationships, trust and effecient result and our priority is the growth and development of our clients businesses.</p>
            {/* <h2 className='text-center'>Work Together - Growth Together</h2> */}
            {/* <h2 className='text-center'> <span style={{ fontSize: '60px' }}>“</span>Together Towards Success<span style={{ fontSize: '60px' }}>”</span></h2> */}
            <h2 className='text-center' style={{ fontFamily: "sans" }}>Welcome to Us - Bharat Rug Agencies</h2>
            {/* <Button as={Link} to="/About" variant="outline-dark" size="lg">Know More</Button> */}
            {/* <h2 className='text-start'><strong>Growth Together</strong></h2> */}
            {/* <div className='typed-text1'>
              <TextType
                text={["Work Together", "Growth Together"]}
                typingSpeed={75}
                pauseDuration={1500}
                showCursor={true}
                cursorCharacter="_"
                textColors={["black"]}
                cursorClassName="text-black"
              />
            </div> */}

          </Col>
          {/* <Col md={6} className='p-5'>
            <img src={AboutImg} alt="About" width="100%" />
          </Col> */}
        </Row>
        {/* <hr style={{ border: '2px', height: '2px', backgroundColor: 'red' }} /> */}
      </Container>

      {/* <Container>
        <h1 className="text-center my-4 text-decoration-underline"><strong>Our Products</strong></h1>
        <Row className="g-4 justify-content-center my-4"> */}
          {/* Furniture */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Furniture" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img
                    src={Furniture}
                    alt="Furniture"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }}
                  />
                }
                secondContent={
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "grid",
                      placeItems: "center",
                      backgroundColor: "#111",
                      aspectRatio: "4/3",
                    }}
                  >
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>
                      Furniture
                    </p>
                  </div>
                }
                gridSize={12}
                pixelColor="#ffffff"
                animationStepDuration={0.4}
                className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Rug */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Rugs" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Rug} alt="Rug" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Rug</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Cushions */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Cushions" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Cushions} alt="Cushions" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Cushions</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Bed & Bath */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/BedBath" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={BedBath} alt="BedBath" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Bed & Bath</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Kitchen & Dining */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/KitchenDining" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={KitchenDining} alt="KitchenDining" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Kitchen & Dining</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Accessories */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Accessories" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={DecorAccessories} alt="Accessories" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Accessories</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Lights */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Lighting" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Lights} alt="Lights" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Lights</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Bags */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Bags" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Bag} alt="Bag" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Bags</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Holiday */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Holiday" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Holiday} alt="Holiday" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Holiday</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}
        {/* </Row>
      </Container> */}

    </>
  );
}

export default DarkVariantExample;